//网球 中国网球公开赛 full
import PlatfromTennisCupFullChinaOpen from '@containers/platfrom_tennis/tennisCupFull_chinaOpen.vue'

export default {
  PlatfromTennisCupFullChinaOpen,
}
